export const defaultDek =
  "The Atlantic covers news, politics, culture, technology, health, and more, through its articles, podcasts, videos, and flagship magazine.";

export const defaultMetaImage =
  "https://cdn.theatlantic.com/assets/static/b/theatlantic/img/lacroix-default-thumbnail.png";
